export const clearSessionStorage = (): void => {
    if (!sessionStorage) return
    sessionStorage.clear()
}

export const localStorageAvailable =
    typeof window !== 'undefined' && !!window.localStorage

export const setLocalStorage = (key: string, data: string) => {
    try {
        localStorage.setItem(key, data)
    } catch (ex) {
        console.warn('Cannot set local storage', ex)
    }
}

export const getLocalStorageValue = (key: string) => {
    try {
        return localStorage.getItem(key)
    } catch (ex) {
        console.warn('Cannot get from local storage', ex)
        return undefined
    }
}
